<template>
  <div>
    <b-modal id="editModal" ok-title="ذخیره" cancel-title="انصراف" @ok="save">
        <b-form-group label="مبلغ">
            <b-form-input v-model="editItem.cost"></b-form-input>
        </b-form-group>
        <b-form-group label="کارمزد شپا">
            <b-form-input v-model="editItem.shepa_karmozd"></b-form-input>
        </b-form-group>
        <b-form-group label="کارمزد شاپرک">
            <b-form-input v-model="editItem.shaparak_karmozd"></b-form-input>
        </b-form-group>
    </b-modal>
    <b-card title="تسویه ها">
      <div class="row">
        <div class="col-md-4">
          <b-form-group label="تاریخ:">
            <date-picker v-model="date" clearable></date-picker>
          </b-form-group>
        </div>
      </div>
      <div>
        <b-button
          class="btn btn-success"
          @click="getdata"
          :class="isBusy ? 'spinner spinner-light spinner-right' : ''"
          >بروزرسانی</b-button
        >
      </div>
      <b-table responsive :items="sattlements" :fields="bardashtReezFields">
        <template v-slot:cell(btns)="row">
          <button
            class="btn btn-primary btn-sm p-0 pl-1 pr-1 mr-1"
            @click="showEdit(row.item)"
          >
            ویرایش
          </button>
        </template>
      </b-table>
    </b-card>
  </div>
</template>
<script>
import moment from "jalali-moment";
// import TableShowData from "../../../components/table.vue";
import httpHelper from "../../../helpers/httpHelper";
export default {
  name: "SattlementOfDate",
  components: {
    // "list-table": TableShowData,
  },
  data() {
    return {
      isBusy: false,
      sattlements: [],
      editItem: {},
      url: "~transaction/operation/Payouts",
      date: moment().format("jYYYY/jM/jD"),
      bardashtReezFields: [
        {
          key: "acceptor_code",
          label: "کد پذیرنده",
        },
        {
          key: "gateway.website_name",
          label: "وبسایت",
        },
        {
          key: "sale_refrence_id",
          label: "کد رهگیری پرداخت",
        },
        {
          key: "cost",
          label: "مبلغ",
          formatter: (value, key, item) => {
            return Number(-1 * value).toLocaleString();
          },
        },
        {
          key: "shepa_karmozd",
          label: "کارمزد شپا",
          formatter: (value, key, item) => {
            if (value < 0) {
              return Number(-1 * value).toLocaleString();
            }
            return value;
          },
        },
        {
          key: "shaparak_karmozd",
          label: "کارمزد نظام بانکی",
          formatter: (value, key, item) => {
            if (value < 0) {
              return Number(-1 * value).toLocaleString();
            }
            return value;
          },
        },
        {
          key: "btns",
          label: "",
        },
      ],
    };
  },
  mounted() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.isBusy = true;
      httpHelper.getData(this.url + "?date=" + this.date).then((res) => {
        this.sattlements = res.result;
        this.isBusy = false;
      });
    },
    save(e) {
      e.preventDefault();
      httpHelper
        .postData("~transaction/operation/sattlementForDay", this.editItem)
        .then((res) => {
          this.getdata();
          this.$bvModal.hide("editModal");
        });
    },
    showEdit(item) {
      this.editItem = item;
      this.$bvModal.show("editModal");
    },
  },
};
</script>